export default {
  'Cases types': 'Kiste type',
  'Possible contents of the case': 'Mulige skins fra denne kisten',
  'Other cases': 'Andre kister',
  'Open for': 'Åpne for',
};
